import { UpgradeRegistryItem } from '../upgrader.types'
/**
 * component 对应组件类型
 * form 从某个版本开始升级
 * to 升级到的版本
 * upgrade 升级方法，具体的值
 *  {
      from: 1,
      to: 2,
      upgrade(schema) {
        // 添加 autoFitHeight 属性，默认为 false
        // if (!('autoFitHeight' in schema.prop)) {
        //   schema.prop.autoFitHeight = false
        // }
        return schema
      }
    }
 */
export const hhTableUpgrades: UpgradeRegistryItem = {
  component: 'HHTable',
  upgrades: [
    {
      from: 1,
      to: 2,
      upgrade(schema) {
        // 添加 autoFitHeight 属性，默认为 false
        // if (!('autoFitHeight' in schema.prop)) {
        //   schema.prop.autoFitHeight = false
        // }
        return schema
      }
    },
    {
      from: 2,
      to: 3,
      upgrade(schema) {
        // 添加rowHeight行高属性
        if (!('rowHeight' in schema.styleProp)) {
          schema.styleProp.rowHeight = 48
        }
        return schema
      }
    }
  ]
}
